import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { BrowserRouter } from "react-router-dom";
import { Theme } from "@radix-ui/themes";
import App from "./App";
import "./index.css";

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!publishableKey) {
  console.warn(
    "Missing VITE_CLERK_PUBLISHABLE_KEY — auth features will not work until you add it to .env.local"
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ClerkProvider
      publishableKey={publishableKey ?? "pk_test_placeholder"}
      appearance={{
        variables: {
          colorPrimary: "#10b981",
          borderRadius: "14px",
          fontFamily: '"Plus Jakarta Sans", sans-serif',
        },
      }}
      localization={{
        signIn: {
          start: {
            title: "Masuk ke BRIBA",
            subtitle: "Lihat posisi keuanganmu, kurangi yang bukan syar'i.",
          },
        },
      }}
    >
      <Theme appearance="light" accentColor="green" grayColor="sand" radius="large" panelBackground="solid">
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Theme>
    </ClerkProvider>
  </StrictMode>
);
